import { SearchScenarioId } from 'owa-search-next-common';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';
import { action } from 'satcheljs';

const onGuidedFormulationSuggestionSelected = action(
    'onGuidedFormulationSuggestionSelected',
    (
        segments: SubstrateSearchSuggestionSegment[],
        suggestionSelected: boolean,
        scenarioId: SearchScenarioId
    ) => ({
        segments,
        suggestionSelected,
        scenarioId,
    })
);

export default onGuidedFormulationSuggestionSelected;
